<template>
    <el-cascader v-model="currentValue"
        @change="onChange"
        @expand-change="onExpandChange"
        @visible-change="onVisibleChange"
        @remove-tag="onRemoveTag"
        @clear="onClear"
        @blur="onBlur"
        @focus="onFocus"
        :options="dataSource"
        :separator="separator"
        :props="props"
        :placeholder="placeholder"
        :multiple="multiple"
        :multiple-limit="multipleLimit"
        :disabled="disabled"
        :clearable="clearable"
        :collapse-tags="collapseTags"
        :filterable="filterable"
        :no-match-text="noMatchText"
        :no-data-text="noDataText">
    </el-cascader>
</template>

<script>
import Select from './select.js'
export default {
    name: 'v-cascader',
    mixins: [Select],
    props: {
        value: {
            type: Array,
            default () {
                return []
            }
        },
        separator: {
            type: String,
            default: '/'
        },
        props: {
            type: String,
            deafult () {
                return {
                    value: 'id'
                }
            }
        }
    },
    data () {
        return {
            currentValue: []
        }
    },
    methods: {
        onExpandChange (e) {
            this.$emit('expand-change', e)
        },
        onChange (e) {
            this.$emit('change', e)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/framework/widgets/cascader.vue